import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import type { SectionType } from '../../types';

export interface SectionDetails {
  id: string;
  data: Record<string, unknown>;
  sectionType: SectionType;
}

export const sectionDetailsQueryKey = (websiteId: string, pageId: string, sectionId: string) =>
  ['plus-website-section-details', { websiteId, pageId, sectionId }] as const;

async function fetchSectionDetails(websiteId: string, pageId: string, sectionId: string) {
  const { data } = await axiosPrivate.get<SectionDetails>(
    `/v3/pharmacist/plus-websites/${websiteId}/versions/preview/pages/${pageId}/sections/${sectionId}`
  );
  return data;
}

export function useGetSectionDetails({
  websiteId,
  pageId,
  sectionId,
}: {
  websiteId: string;
  pageId: string;
  sectionId: string;
}) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: sectionDetailsQueryKey(websiteId, pageId, sectionId),
    queryFn: () => fetchSectionDetails(websiteId, pageId, sectionId),
    enabled: !!websiteId && !!pageId && !!sectionId,
    meta: { errorMessage: 'Failed to load section details' },
  });

  return { sectionDetails: data, isLoading, isError, error };
}
